export * from "./user.constants";
export * from "./company.constants";
export * from "./mode.constants";
export * from "./recruiter.constants";
export * from "./candidate.constants";
export * from "./project.constants";
export * from "./activity.constants";
export * from "./status.constants";
export * from "./dashboard.constants";
export * from "./type.constants";
export * from "./invoice.constants";
export * from "./screen.constants";
export * from "./serverResponse/serverResponse.constants";

export const globalConstants = {
  EMPTY_STRING: "",
  SUCCESS: "_SUCCESS",
  FAILIUR: "_FAILIUR",
  FILTER_EXPRESSION: "aXNBY3RpdmU9PXRydWV8fGlzQWN0aXZlPT1mYWxzZQ==",
  SORT: {
    ASC: "asc",
    DESC: "desc",
  },
};

export const TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
};
